import { render, staticRenderFns } from "./ModalCreateNewValue.vue?vue&type=template&id=1e038de1&scoped=true"
import script from "./ModalCreateNewValue.vue?vue&type=script&lang=js"
export * from "./ModalCreateNewValue.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateNewValue.vue?vue&type=style&index=0&id=1e038de1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e038de1",
  null
  
)

export default component.exports